import { FormField } from '@domain-group/suit-theme'

import type { UseOrderApprovalPayload } from '@modals/ApproveOrderModal/hooks/useOrderApproval'

type PurchaseOrderProps = {
  orderApprovalPayload: UseOrderApprovalPayload,
}

const PurchaseOrder = (props: PurchaseOrderProps) => {
  const {
    orderApprovalPayload: {
      callbacks: { setEntityState, updateOrder },
      entityState: { purchase_order },
      order: { id },
    },
  } = props

  return (
    <FormField direction="column" label="Purchase Order #">
      <input
        onBlur={e => updateOrder({ id, purchase_order: e.target.value })}
        onChange={e => setEntityState({ purchase_order: e.target.value })}
        type="text"
        value={purchase_order}
      />
    </FormField>
  )
}

export default PurchaseOrder
